// src/realtime/jobsHubClient.ts
import * as signalR from "@microsoft/signalr";

const HUB_URL = `${process.env.REACT_APP_API_BASE_URL}/hubs/jobs`;

let connection: signalR.HubConnection | null = null;

export function getJobsHubConnection() {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, { withCredentials: true })
      .withAutomaticReconnect()
      .build();
  }

  return connection;
}
